import { useLocale as useDsLocale } from '@daysmart/daysmart-vue-components/composables'
import { useFormKitConfig } from '@daysmart/daysmart-vue-components/formkit/composables'
import { useEnterpriseClient } from './useEnterpriseClient'
import getCookie from '~/core/utils/getCookie'
import setCookie from '~/core/utils/setCookie'
import getBrowserLocale from '~/core/utils/getBrowserLocale'

function createInstance() {
  const { locale } = useDsLocale()
  const formkitConfig = useFormKitConfig()
  const { locale: i18nLocale } = useI18n({ useScope: 'global' })
  const { isPeloton } = useEnterpriseClient()

  const getInitialLocale = () => {
    if (isPeloton)
      return getBrowserLocale()
    return getCookie('django_language')
      // || getLocaleFromProviderCountry()
      || getBrowserLocale()
  }

  locale.value = getInitialLocale()

  watch(
    locale,
    (value) => {
      setCookie('django_language', value)
      i18nLocale.value = value
      if (formkitConfig)
        formkitConfig.locale = value.slice(0, 2)
    },
    { immediate: true },
  )

  return { locale }
}

export const useLocale = useSingleton(createInstance)
